'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _legalContent = require('../../../molecules/legal-content');

var _legalContent2 = _interopRequireDefault(_legalContent);

var _locales = require('../js/locales');

var _locales2 = _interopRequireDefault(_locales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var EnhancedLegal = function (_React$Component) {
  _inherits(EnhancedLegal, _React$Component);

  function EnhancedLegal(props) {
    _classCallCheck(this, EnhancedLegal);

    var _this = _possibleConstructorReturn(this, (EnhancedLegal.__proto__ || Object.getPrototypeOf(EnhancedLegal)).call(this, props));

    _this.renderIndex = function (count, indexType) {
      switch (indexType) {
        case 'index-bullets':
          return '•';
        case 'index-numbers':
          return count + '.';
        case 'index-upper-letters':
          return String.fromCharCode(count + 64) + '.';
        case 'index-lower-letters':
          return String.fromCharCode(count + 96) + '.';
        default:
          return '';
      }
    };

    _this.ORGANISM_NAME = 'enhanced-legal';
    var config = _this.props.config;
    var id = config.id;
    // we use this id because we can only have one organism per page

    _this.id = id || _this.ORGANISM_NAME;
    _this.state = {
      showImages: false
    };
    return _this;
  }

  _createClass(EnhancedLegal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      if (this.state.showImages) {
        return _react2.default.createElement('img', { id: 'print_pic', src: 'https://www.paypalobjects.com/webstatic/ua/printer_icon.jpg', alt: 'print' });
      }
      return null;
    }
  }, {
    key: 'renderBreadcrumbs',
    value: function renderBreadcrumbs(breadcrumbs) {
      if (breadcrumbs && breadcrumbs.text) {
        return _react2.default.createElement(
          'p',
          { className: this.ORGANISM_NAME + '__breadcrumbs-text' },
          htmlToReactParser.parse(breadcrumbs.text)
        );
      }
      return null;
    }
  }, {
    key: 'renderHeadline',
    value: function renderHeadline(headline, level) {
      var isNumeric = function isNumeric(value) {
        return (/^-{0,1}\d+$/.test(value)
        );
      };
      var validHeadlines = [1, 2, 3, 4, 5, 6];
      var isValidLevel = function isValidLevel(vLevel) {
        if (isNumeric(vLevel)) {
          if (validHeadlines.indexOf(parseInt(vLevel, 10)) > -1) {
            return true;
          }
          return false;
        }
        return false;
      };
      if (headline) {
        var lvl = isValidLevel(level) ? level : 3;
        return _react2.default.createElement(
          _heading2.default,
          { level: lvl, className: this.ORGANISM_NAME + '__headline pp-sans-small-regular h' + lvl },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }
  }, {
    key: 'renderTimestamp',
    value: function renderTimestamp(timestamp) {
      if (timestamp && timestamp.text) {
        return _react2.default.createElement(
          'p',
          { className: this.ORGANISM_NAME + '__timestamp-text' },
          htmlToReactParser.parse(timestamp.text)
        );
      }
      return null;
    }
  }, {
    key: 'renderParagraph',
    value: function renderParagraph(paragraph) {
      if (paragraph && paragraph.text) {
        return _react2.default.createElement(
          'p',
          { className: this.ORGANISM_NAME + '__linked-content-text' },
          htmlToReactParser.parse(paragraph.text)
        );
      }
      return null;
    }
  }, {
    key: 'renderLegalhub',
    value: function renderLegalhub(legalhub) {
      if (legalhub) {
        var targetPagePath = legalhub.targetPagePath,
            selectLocation = legalhub.selectLocation;

        if (targetPagePath && targetPagePath.text) {
          var localesOptions = _locales2.default.map(function (loc) {
            var locale = loc.language + '_' + loc.country.toUpperCase();
            var fixedPath = targetPagePath.text[0] === '/' ? targetPagePath.text.substr(1) : targetPagePath.text;
            var optionProps = {
              value: 'https://www.paypal.com/' + loc.country.toLowerCase() + '/webapps/mpp/' + fixedPath + '?locale.x=' + locale,
              key: locale
            };
            if (loc.dir) {
              optionProps.dir = loc.dir;
            }
            return _react2.default.createElement(
              'option',
              optionProps,
              loc.label
            );
          });
          return _react2.default.createElement(
            'div',
            { className: this.ORGANISM_NAME + '__legalhub' },
            _react2.default.createElement(
              'select',
              {
                id: this.ORGANISM_NAME + '-legalhub',
                onChange: function onChange(e) {
                  if (e.target.value) {
                    window.location = e.target.value;
                  }
                  return false;
                }
              },
              _react2.default.createElement(
                'option',
                { value: '' },
                selectLocation.text
              ),
              localesOptions
            )
          );
        }
        return null;
      }
      return null;
    }
  }, {
    key: 'renderPrintable',
    value: function renderPrintable(printable) {
      if (printable) {
        return _react2.default.createElement(
          'p',
          { id: 'ua_skinny_view', align: 'right' },
          this.renderImage(),
          _react2.default.createElement(
            'button',
            {
              className: 'link-button',
              id: this.id + '-print',
              onClick: function onClick() {
                window.print();
              }
            },
            'Print'
          )
        );
      }
      return null;
    }
  }, {
    key: 'renderLinkedContent',
    value: function renderLinkedContent(linkedContent) {
      var _this2 = this;

      if (linkedContent) {
        var backToTop = linkedContent.backToTop,
            indexType = linkedContent.indexType,
            items = linkedContent.items,
            jumpToSection = linkedContent.jumpToSection,
            paragraph = linkedContent.paragraph;

        var jumpLinks = [];
        var paragraphs = [];
        items.forEach(function (item, index) {
          var count = index + 1;
          var uniqueIndex = _this2.id + '-' + index;
          jumpLinks.push(_react2.default.createElement(
            'li',
            { key: uniqueIndex },
            _react2.default.createElement(
              'a',
              { href: '#' + uniqueIndex },
              _this2.renderIndex(count, indexType),
              ' ',
              htmlToReactParser.parse(item.headline.text)
            )
          ));
          paragraphs.push(_react2.default.createElement(
            'div',
            { id: uniqueIndex, key: uniqueIndex },
            _this2.renderHeadline({
              text: _this2.renderIndex(count, indexType) + ' ' + item.headline.text
            }),
            _react2.default.createElement(_legalContent2.default, {
              content: {
                paragraph: item.paragraph,
                table: item.table,
                paragraph2: item.paragraph2
              }
            }),
            _react2.default.createElement(
              'p',
              { align: 'right', className: _this2.ORGANISM_NAME + '__linked-content-bold-text' },
              _react2.default.createElement(
                'a',
                { href: '#' + _this2.id },
                backToTop.text
              )
            )
          ));
        });
        return _react2.default.createElement(
          'div',
          { id: this.id + '-links', className: this.ORGANISM_NAME + '__linked-content' },
          _react2.default.createElement(
            'p',
            { className: this.ORGANISM_NAME + '__linked-content-bold-text' },
            htmlToReactParser.parse(jumpToSection.text)
          ),
          _react2.default.createElement(
            'ul',
            { className: this.ORGANISM_NAME + '__linked-content--jump-links' },
            jumpLinks.map(function (jLink) {
              return jLink;
            })
          ),
          this.renderParagraph(paragraph),
          paragraphs.map(function (para) {
            return para;
          })
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var theme = config.theme,
          printable = config.printable;


      var legalEnhancedClasses = (0, _classnames2.default)('' + this.ORGANISM_NAME, theme || 'theme-background-color-white', className);

      var breadcrumbs = content.breadcrumbs,
          headline = content.headline,
          legalhub = content.legalhub,
          linkedContent = content.linkedContent,
          paragraph = content.paragraph,
          timestamp = content.timestamp;


      return _react2.default.createElement(
        'section',
        {
          className: legalEnhancedClasses,
          'data-building-block': 'organism',
          id: this.id,
          ref: function ref(el) {
            _this3.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 center-block' },
              this.renderBreadcrumbs(breadcrumbs),
              this.renderHeadline(headline, 1),
              this.renderTimestamp(timestamp),
              this.renderPrintable(printable),
              this.renderParagraph(paragraph),
              this.renderLegalhub(legalhub),
              this.renderLinkedContent(linkedContent)
            )
          )
        )
      );
    }
  }]);

  return EnhancedLegal;
}(_react2.default.Component);

exports.default = EnhancedLegal;


EnhancedLegal.defaultProps = {
  config: {
    id: 'enhanced-legal',
    theme: 'theme-background-color-white',
    printable: true
  },
  content: {
    breadcrumbs: {
      text: '&gt;&gt; <a href="#" title="Legal Agreements" pa-marked="1">View all legal agreements</a>'
    },
    headline: {
      text: 'Legal Content Headline'
    },
    timestamp: {
      text: 'Last Update: May 19, 2019'
    },
    paragraph: {
      text: '2,000 characters maximum is recommended.'
    },
    legalhub: {
      selectLocation: {
        text: 'Select your location'
      },
      targetPagePath: {
        text: 'target-page'
      }
    },
    linkedContent: {
      jumpToSection: {
        text: 'Jump to section:'
      },
      indexType: '',
      paragraph: {
        text: '2,000 characters maximum is recommended.'
      },
      backToTop: {
        text: 'Back to top'
      },
      items: [{
        headline: {
          text: 'Product Description.'
        },
        paragraph: _legalContent2.default.defaultProps.content.paragraph,
        table: _legalContent2.default.defaultProps.content.table,
        paragraph2: _legalContent2.default.defaultProps.content.paragraph2
      }, {
        headline: {
          text: 'Getting, Using and Replacing your PayPal Here Device.'
        },
        paragraph: _legalContent2.default.defaultProps.content.paragraph,
        table: _legalContent2.default.defaultProps.content.table,
        paragraph2: _legalContent2.default.defaultProps.content.paragraph2
      }]
    }
  },
  className: ''
};

EnhancedLegal.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    printable: _propTypes2.default.bool,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light'])
  }),
  content: _propTypes2.default.shape({
    breadcrumbs: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    timestamp: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    legalhub: _propTypes2.default.shape({
      selectLocation: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      targetPagePath: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired
    }),
    linkedContent: _propTypes2.default.shape({
      jumpToSection: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      indexType: _propTypes2.default.oneOf(['', 'index-bullets', 'index-numbers', 'index-upper-letters', 'index-lower-letters']).isRequired,
      paragraph: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      backToTop: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        headline: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        }).isRequired,
        paragraph: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        }),
        table: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        }),
        paragraph2: _propTypes2.default.shape({
          text: _propTypes2.default.string.isRequired
        })
      }).isRequired)
    })
  }),
  className: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/enhanced-legal/jsx/EnhancedLegal.js
// module id = 1087
// module chunks = 4